import { render, staticRenderFns } from "./matter-work-navigator.vue?vue&type=template&id=7cd85582&scoped=true&"
import script from "./matter-work-navigator.vue?vue&type=script&lang=ts&"
export * from "./matter-work-navigator.vue?vue&type=script&lang=ts&"
import style0 from "./matter-work-navigator.vue?vue&type=style&index=0&id=7cd85582&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd85582",
  null
  
)

export default component.exports